module.exports = __webpack_public_path__ + "media/images/themes/mandy/13 (copy)-cbb683bc6827db4f91e34b2b8a1ac804.png";